import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo, useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';
import { getRandomId } from '../Utils/baseComponentHelper.js';
import useForm from '../Hooks/useForm.js';
import useActivation from '../Hooks/useActivation.js';
import useRadioFormChecked from './useRadioFormChecked.js';
import { NOOP } from '../../utils/const.js';

/**
I radio button devono essere utilizzati quando si ha la necessità che l’utente possa vedere tutte le opzioni
disponibili di una determinata scelta.

Ref: input reference.
 */
const Radio = forwardRef((props, ref) => {
    const { className, disabled: disabledProp, readOnly: readOnlyProp, name, value, checked, label, tooltip, onChange } = props, others = __rest(props, ["className", "disabled", "readOnly", "name", "value", "checked", "label", "tooltip", "onChange"]);
    const { onFormChange, stato, notifica, } = useForm(name, NOOP, true);
    const uniqueid = useMemo(() => getRandomId(), []);
    const inputChecked = useRadioFormChecked({
        stato, name, value, checked,
    });
    const radioId = `${name}_${value}_${uniqueid}`;
    const { active, disabled, readOnly } = useActivation(disabledProp, readOnlyProp);
    const classes = cns((label ? undefined : className), {
        radio: !label,
        'radio--disabled': disabled,
        'radio--enabled': active,
        'radio--readOnly': readOnly,
        'radio--checked': inputChecked,
    });
    const classesLabel = cns(className, {
        radio: label,
        'radio--labeled': label,
        'label--disabled': disabled,
        'label--readOnly': readOnly,
        'label--checked': inputChecked,
        'label--unchecked': !inputChecked,
    });
    const handleChange = useCallback((e) => {
        if (active)
            notifica(e, name, e.target.value, onChange, onFormChange, stato);
    }, [active, name, notifica, onChange, onFormChange, stato]);
    return (label ? (jsxs("label", { className: classesLabel, htmlFor: radioId, title: tooltip, children: [jsxs("span", { className: classes, children: [jsx("input", Object.assign({ ref: ref }, others, { id: radioId, disabled: disabled, checked: inputChecked, onChange: handleChange, title: tooltip, type: "radio", value: value })), jsx("span", {})] }), jsx("span", { className: "radio__label", children: label })] })) : (jsxs("span", { className: classes, children: [jsx("input", Object.assign({ ref: ref }, others, { disabled: disabled, checked: inputChecked, onChange: handleChange, title: tooltip, type: "radio", value: value })), jsx("span", {})] })));
});
Radio.defaultProps = {
    checked: false,
    className: '',
    disabled: false,
    readOnly: false,
    name: '',
    onChange: null,
    value: null,
    label: null,
    tooltip: null,
};

export { Radio as default };
